<template>
  <b-modal ref="modal" visible size="lg" :hide-footer="true" title="Productdetails" @hidden="$emit('close')">
      <div class="block block-bordered">
        <div class="block-header block-header-default" style="display: block;">
          <h6>Nieuwe order notificatie</h6>
        </div>
          <div class="block-content">
            <form  onsubmit="return false">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="Barcode">Notificatie tekst:</label>
                        <input v-model="orderNotification.notification_text" type="text" class="form-control form-control-lg" >
                    </div>
                    <div class="form-group col-md-6">
                        <label for="Location">Bedrag:</label>
                        <input v-model="orderNotification.amount" type="number" class="form-control form-control-lg">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label>Merken:</label>
                        <multiselect v-model="orderNotification.settings.brands" :multiple="true" :options="brands" placeholder="Selecteer merken" selected-label="✔" select-label="" deselect-label="✔" allow-input/>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label class="css-control css-control-sm css-control-primary css-switch "> 
                            <input type="checkbox" class="css-control-input" v-model="orderNotification.settings.exclude_sale_products">
                            <span class="css-control-indicator"></span> Sales producten uitsluiten:
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label class="css-control css-control-sm css-control-primary css-switch ">
                            <input type="checkbox" class="css-control-input" v-model="orderNotification.status">
                            <span class="css-control-indicator"></span> Actief
                        </label>
                    </div>
                </div>
                <button type="submit" class="btn btn-success btn-noborder" @click="save">
                    Opslaan
                </button>
            </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import http from '../utils/http'

export default {
  props: {
    orderNotification: Object
  },
  data () {
    return {
      brands: []
    }
  },
  methods: {
    loadBrands () {
      http.get('brands')
      .then((result) => {
        this.brands = result.data.data
      })
    },
    save () {
      if (!this.orderNotification.id) {
        http.post(`/order-notification`, this.orderNotification)
        .then((result) => {
          this.$swal('Hoera 😊', `Nieuwe order notificatie is succesvol aangemaakt.`, 'success')
          this.$refs.modal.hide()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het aanmaken van een nieuwe order notificatie', 'warning')
        })
      } else {
        http.patch(`/order-notification/${this.orderNotification.id}`, this.orderNotification)
        .then((result) => {
          this.$swal('Hoera 😊', `Order notificatie is succescol geupdate.`, 'success')
          this.$refs.modal.hide()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het updaten van de order notificatie', 'warning')
        })
      }
    }
  },
  created () {
    this.loadBrands()
  }
}
</script>




// WEBPACK FOOTER //
// OrderNotificationEditModal.vue?3b6ab198